<leaflet-map id="propriedade-map" bounds="map.bounds"/>
  <agro-legenda-mapa legendas="legendas" ng-show="legendas" humanize="true"/>
<propriedade-active-heatmap maps="activeHeatmaps" map-type="headMapType"/>
